import React from 'react';

import { BenefitContainer, BenefitExplanation, BenefitTitle } from '../styled/StyledModal';

import { BenefitIcon } from './BenefitIcon';

export const Benefit = ({
	benefit,
	explanation,
	usingBenefit,
	benefitTitle,
}: {
	benefit: string;
	explanation: string;
	usingBenefit?: boolean;
	benefitTitle: string;
}) => (
	<BenefitContainer>
		<BenefitIcon usingBenefit={usingBenefit} benefitTitle={benefitTitle} />
		<div>
			<BenefitTitle>{benefit}</BenefitTitle>
			<BenefitExplanation>{explanation}</BenefitExplanation>
		</div>
	</BenefitContainer>
);
